module.exports = __webpack_public_path__ + "static/media/13-Learning-Good-Consent.d323a94e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/13-Learning-Good-Consent.jpg
// module id = 148
// module chunks = 0